import { DraasApiExecutionInfo } from '@pure/paas-api-gateway-client-ts';
import moment from 'moment';
import { DisasterRecoveryJobType } from './disaster-recovery-job-execution-with-steps';

export class DisasterRecoveryJobExecutionInfo {
    id: string;
    status: string;
    start: moment.Moment;
    end?: moment.Moment;
    executedOn: moment.Moment;
    purpose?: DisasterRecoveryExecutionPurpose;
    description?: string;
    jobType?: DisasterRecoveryJobType;

    constructor(json: DraasApiExecutionInfo) {
        this.id = json.id;
        this.executedOn = json.executed_on ? moment.utc(json.executed_on) : null;
        this.status = json.status;
        this.start = moment.utc(json.start);
        this.end = json.end ? moment.utc(json.end) : null;
        this.description = json.description;
        this.jobType = json.job_type;
        this.purpose = json.purpose;
    }
}

export type DisasterRecoveryExecutionPurpose =
    | 'PROTECTION'
    | 'FAILOVER'
    | 'FAILOVER_TEST'
    | 'FAILOVER_PROD'
    | 'TEARDOWN'
    | 'FAILBACK'
    | 'UNENROLL'
    | 'FAILBACK_SYNC'
    | 'FAILBACK_CUTOVER'
    | 'FAILBACK_PROMOTE';
